import { createStore, withProps } from '@ngneat/elf';
import {
  QuestionTask,
  QuestionValidationRequest,
  AdditifGroup,
  DemandeReportsResponse,
  downloadEclaircissementDTO
} from '@/types';

export interface ClarificationStateProps {
  response: QuestionTask | AdditifGroup | null;
  dto?: Partial<QuestionValidationRequest>;
  initialDto?: Partial<QuestionValidationRequest>;
  downloadModeldemandeEclDto?: Partial<downloadEclaircissementDTO>;
  upload: {
    modelFile: File | null;
    noteFile: File | null;
    noteComment: string;
  };
  demandeReports: DemandeReportsResponse | null;
}

export const clarificationInitialDto: QuestionValidationRequest = {
  validate: true,
  answer: '',
  typeQuestion: 'SIMPLE',
  haveReport : false,
  dateReport: null,
};

export const clarificationInitialState: ClarificationStateProps = {
  response: null,
  dto: structuredClone(clarificationInitialDto),
  initialDto: structuredClone(clarificationInitialDto),
  downloadModeldemandeEclDto: {
    demandeId: undefined,
    haveReport: false,
    dateReport: undefined,
  },
  upload: {
    modelFile: null,
    noteFile: null,
    noteComment: '',
  },
  demandeReports: null,
};

export const clarificationStateStore = createStore(
  { name: 'clarification-state' },
  withProps<ClarificationStateProps>({
    ...clarificationInitialState,
  })
);
